import CatNavMenu from './catNavMenu'

export default CatNavMenu
